import styled from "styled-components";

const H3 = styled.h3`
  width: 100%;
  font-size: 24px;
  margin: 0;
  padding: 0;
  color: #cc9507;
`;

export default H3;
